import React from 'react';
import PropTypes from 'prop-types';

import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import {SearchFilter} from '@utils/commonFilters/SearchFilter';
import {EncodingDatacentersFilter} from '@utils/commonFilters/EncodingDatacentersFilter';
import {ContentCategoriesFilter} from '@utils/commonFilters/ContentCategoriesFilter';
import {TournamentsFilter} from '@utils/commonFilters/TournamentsFilter';

const UdpOriginEntryPointFilters = ({
    data: {
        contentCategories = [],
        encodingDatacenters = [],
        tournaments = [],
    },
    filters,
    loading,
    restoreFilterValues,
}) => {
    return (
        <div className='udpOriginEntryPoint__filters filter__controls__container'>
            <SearchFilter
                loading={loading}
                filters={filters.udpOriginEntryPoints}
                restoreFilterValues={restoreFilterValues}
            />
            <EncodingDatacentersFilter
                encodingDatacenters={encodingDatacenters}
                loading={loading}
                filters={filters.udpOriginEntryPoints}
                restoreFilterValues={restoreFilterValues}
            />
            <TournamentsFilter
                tournaments={tournaments}
                loading={loading}
                filters={filters.udpOriginEntryPoints}
                restoreFilterValues={restoreFilterValues}
            />
            <ContentCategoriesFilter
                contentCategories={contentCategories}
                loading={loading}
                filters={filters}
                restoreFilterValues={restoreFilterValues}
                filterName='udpOriginEntryPoints'
            />
        </div>
    );
};

UdpOriginEntryPointFilters.propTypes = {
    data: PropTypes.shape({
        tournaments: PropTypes.array,
        contentCategories: PropTypes.array,
        encodingDatacenters: PropTypes.array,
    }),
    filters: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};

export default FiltersWrapper(UdpOriginEntryPointFilters, {name: 'udpOriginEntryPoints'});
